import { useState } from 'react'

import type { CreateVideoEmbedPostPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import { useImageConfirmMutation } from '../../../hooks/useImageConfirmMutation'
import { useUploadImageMutation } from '../../../hooks/useUploadImageMutation'
import { useCreateVideoEmbedPostMutation } from './useCreateVideoEmbedPostMutation'

export const useCreateVideoEmbedPost = () => {
  const [isLoading, setLoading] = useState(false)

  const { createVideoEmbedPostMutation } = useCreateVideoEmbedPostMutation()

  const { uploadImageMutation } = useUploadImageMutation()
  const { imageConfirmMutation } = useImageConfirmMutation()

  const createVideoEmbedPost = async (
    thumbnail: File,
    payload: CreateVideoEmbedPostPayload,
    handleSuccess: () => void,
  ) => {
    setLoading(true)

    const { postId, imageDirectUploadData } = await createVideoEmbedPostMutation.mutateAsync(
      [payload],
      {
        onSuccess: ({ imageDirectUploadData }) => {
          if (!imageDirectUploadData) {
            setLoading(false)
            handleSuccess()
          }
        },
        onError: () => setLoading(false),
      },
    )

    if (imageDirectUploadData) {
      await uploadImageMutation.mutateAsync([thumbnail, { ...imageDirectUploadData }], {
        onError: () => {
          setLoading(false)

          throw new Error('Memberships: create video embed post upload image error')
        },
      })

      await imageConfirmMutation.mutateAsync(
        [postId, { signedId: imageDirectUploadData.signedId }],
        {
          onSuccess: () => {
            setLoading(false)
            handleSuccess()
          },
          onError: () => {
            setLoading(false)

            throw new Error('Memberships: create video embed post confirm image error')
          },
        },
      )
    }
  }

  return {
    createVideoEmbedPost,
    isLoading,
  }
}
